import { find, findIndex, isEmpty } from 'lodash';
import { ACTIONS, VIEWS } from 'workflow/constants/newInbox';


const initialState = {
    tasks: [],
    tasksFetching: true,
    tasksSigning: false,
    tasksForMultiSign: [],
    taskForSingleSign: {},
    taskForDetailDisplay: {},
    taskDetail: {},
    taskDetailFetching: true,
    documentDetail: {},
    view: VIEWS.TASK_LIST,
    taskDetailPrevious: {},
    taskDetailNext: {},
    currentTaskIndex: 0,
    shouldShowTaskWindowOnTaskLoad: false
};

const newInboxReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.RESET_STATE: {
            return { ...state, ...initialState };
        }
        case ACTIONS.SET_TASK_DETAIL_FETCHING: {
            return {
                ...state,
                taskDetailFetching: action.payload,
                ...(action.payload ? {
                    documentDetail: {},
                    taskDetail: {},
                } : {})
            };
        }
        case ACTIONS.RESET_STATE_TASK_DETAIL: {
            return {
                ...state,
                documentDetail: {},
                taskDetail: {},
                taskDetailFetching: true,
                taskForDetailDisplay: {}
            };
        }
        case ACTIONS.SET_TASKS: {
            const tasks = action.payload || [];
            const tasksForMultiSign = (state.tasksForMultiSign || []).filter(task => tasks.some(t => t.id === task.id));
            if (state.shouldShowTaskWindowOnTaskLoad) {
                return {
                    ...state,
                    tasks,
                };
            }
            else {
                return {
                    ...state,
                    tasks,
                    tasksForMultiSign,
                    taskForSingleSign: {},
                    taskForDetailDisplay: {},
                    taskDetail: {},
                    documentDetail: {}
                };
            }
        }
        case ACTIONS.SET_TASKS_COUNT: {
            const tasksCount = action.payload || [];
            return {
                ...state,
                tasksCount,
            };
        }
        case ACTIONS.SET_MY_TASKS_STUDY_BINDER_NAMES: {
            const myTasksStudyBinderNames = action.payload || [];
            return {
                ...state,
                myTasksStudyBinderNames,
            };
        }
        case ACTIONS.SET_TASKS_FETCHING: {
            return {
                ...state,
                tasksFetching: !!action.payload
            };
        }
        case ACTIONS.SET_TASKS_SIGNING: {
            return {
                ...state,
                tasksSigning: !!action.payload
            };
        }
        case ACTIONS.MARK_TASK_AS_READ: {
            const { tasks } = state;
            const { payload: task = {} } = action;
            const updatedTasks = tasks.filter(t => t.id !== task.id);
            return {
                ...state,
                tasks: updatedTasks
            };
        }
        case ACTIONS.TOGGLE_TASK_FOR_MULTI_SIGN: {
            const tasksForMultiSign = state.tasksForMultiSign || [];
            const { payload: task } = action;
            const updatedTasks = tasksForMultiSign.some(t => t.id === task.id)
                ? tasksForMultiSign.filter(t => t.id !== task.id)
                : [...tasksForMultiSign, task];
            return {
                ...state,
                tasksForMultiSign: updatedTasks
            };
        }
        case ACTIONS.SET_TASK_FOR_SINGLE_SIGN: {
            return {
                ...state,
                taskForSingleSign: action.payload
            };
        }
        case ACTIONS.SET_TASK_FOR_DETAIL_DISPLAY: {
            return {
                ...state,
                taskForDetailDisplay: action.payload || {}
            };
        }
        case ACTIONS.SET_TASK_DETAIL: {
            const task = state.taskForDetailDisplay;
            const currentTaskIndex = findIndex(state.tasks, (s) => s.id == task.id);

            let nextTask = currentTaskIndex > -1 ? find(state.tasks, (s) => s.id == task.nextTask) : {};
            const taskDetailNext = !isEmpty(nextTask) && {
                ...nextTask
            };

            let previousTask = currentTaskIndex > -1 ? find(state.tasks, (s) => s.id == task.previousTask) : {};
            const taskDetailPrevious = !isEmpty(previousTask) && { ...previousTask };
            return {
                ...state,
                taskDetail: {
                    ...task,
                    ...action.payload
                },
                taskDetailFetching: false,
                taskDetailNext,
                taskDetailPrevious,
                currentTaskIndex: currentTaskIndex

            };
        }
        case ACTIONS.CHANGE_VIEW: {
            return {
                ...state,
                view: action.payload || VIEWS.TASK_LIST
            };
        }
        case ACTIONS.TASK_WINDOW_DETAIL: {
            return {
                ...state,
                taskWindowDetail: action.payload,
            };
        }
        case ACTIONS.TASK_WINDOW_SHOW_ON_LOAD_TASK: {
            return {
                ...state,
                shouldShowTaskWindowOnTaskLoad: action.payload,
                currentTaskIndex: action.payload == 'next' ? 0 : action.payload == 'previous' ? null : state.currentTaskIndex
            };
        }
        default: {
            return state;
        }
    }
};

export { initialState };
export default newInboxReducer;
